import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/common.less'
import "swiper/swiper-bundle.min.css"
import moment from 'moment'

Vue.use(ElementUI)
Vue.config.productionTip = false
//日期过滤器
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
})
Vue.filter('ellipsis', function (value) {
    if (!value) return ''
    if (value.length > 12) {
        return value.slice(0, 12) + '...'
    }
    return value
})
Vue.prototype.searchBus = new Vue();

import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js()

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
